<template>
  <div>
    <Header></Header>
    <Search :seachcon="keyword" :catid="id"></Search>
    <Nav></Nav>
    <div class="wrap">
      <div class="container clearfloat">
        <div class="left">
          <div class="left_wrap">
            <div class="basic">
              <div class="nav_title">
                <span>公司基本信息</span>
              </div>
              <div class="message">
                <div class="form-item">
                  <div class="label">公司全称：</div>
                  <div class="form-input">
                    <el-input
                      placeholder="请输入公司全称"
                      v-model="firmName"
                    ></el-input>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">公司地址：</div>
                  <div class="form-input">
                    <el-input
                      placeholder="请输入公司地址"
                      v-model="firmAddress"
                    ></el-input>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">主营业务：</div>
                  <div class="form-input">
                    <el-input
                      placeholder="请输入主营业务"
                      v-model="firmReport"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="relation">
              <div class="nav_title">
                <span>联系人信息</span>
              </div>
              <div class="message">
                <div class="form-item">
                  <div class="label">姓名：</div>
                  <div class="form-input">
                    <el-input
                      placeholder="请输入姓名"
                      v-model="userName"
                    ></el-input>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">联系电话：</div>
                  <div class="form-input">
                    <el-input
                      placeholder="请输入联系电话"
                      v-model="userTel"
                    ></el-input>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">职务：</div>
                  <div class="form-input">
                    <el-input
                      placeholder="请输入职务"
                      v-model="duty"
                    ></el-input>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">邮箱：</div>
                  <div class="form-input">
                    <el-input
                      placeholder="请输入邮箱"
                      v-model="email"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="other">
              <div class="nav_title">
                <span>其它信息</span>
              </div>
              <div class="message">
                <div class="form-item">
                  <div class="label">是否缴纳保证金：</div>
                  <div class="form-input">
                    <el-radio v-model="surrender" label="1">已缴纳</el-radio>
                    <el-radio v-model="surrender" label="0">未缴纳</el-radio>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label">上传附件：</div>
                  <div class="form-upload">
                    <el-upload
                      class="upload-demo"
                      action="String"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :limit="1"
                      accept=".zip"
                      :auto-upload="false"
                      :on-change="
                        (file, fileList) => {
                          handleChange(file, fileList);
                        }
                      "
                      :file-list="fileList"
                      :on-exceed="handleExceed"
                    >
                      <div class="upload_btn">上传文件</div>
                    </el-upload>
                    <p class="toast">
                      {{
                        bidDetail.file_prompt
                          ? bidDetail.file_prompt
                          : "请将①营业执照清晰正面照；②保证金打款凭证截图或证明；③相关授权书或检验报告；④加密竞标文件等相关图片、文件打包上传"
                      }}
                    </p>
                  </div>
                </div>
                <div class="form-item">
                  <div class="label label_ra">备注：</div>
                  <div class="form-input">
                    <el-input
                      type="textarea"
                      v-model="rebrink"
                      resize="none"
                    ></el-input>
                    <p class="toast">注：没有请填写无</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="reload">
              <div class="reload_btn" @click="submit">提交</div>
            </div>
          </div>
        </div>

        <div class="right">
          <div class="content">
            <div class="nav_title">
              <span>投标项目</span>
            </div>
            <div class="main">
              <p class="bidTitle">{{ bidDetail.title }}</p>
              <p class="bidTime">
                截止投标 剩余<span>{{ bidDetail.residue_time }}</span
                >天
              </p>
              <template v-if="bidDetail.purchaser_name">
                <div class="fordetail">
                  <div class="item">
                    <span class="label">采购商:</span
                    >{{ bidDetail.purchaser_name }}
                  </div>
                  <div class="item">
                    <span class="label">发布时间:</span
                    >{{ bidDetail.tender_time }}
                  </div>
                  <div class="item">
                    <span class="label">项目编号:</span
                    >{{ bidDetail.tender_no }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from "@/components/header/header";
import Search from "@/components/search/search";
import Nav from "@/components/nav/nav";
import Foot from "@/components/foot/foot";
import axios from "axios";
import { set } from "vue";
export default {
  data() {
    return {
      keyword: this.$route.query.keyword, // 搜索文字
      id: "",
      firmName: "", //公司全称
      firmAddress: "", //公司地址
      firmReport: "", //主营业务
      userName: "", //姓名
      userTel: "", //联系电话
      duty: "", //职务
      email: "", //邮箱
      surrender: "1", //是否缴纳保证金
      fileList: [], //上传
      putfile: "", //要提交的文件列表
      rebrink: "", //备注
      bidId: this.$route.query.id,
      bidDetail: {},
    };
  },
  components: {
    Search,
    Header,
    Nav,
    Foot,
  },
  created() {
    this.getDetail();
  },
  mounted() {},
  methods: {
    getDetail() {
      let that = this;
      let params = {
        id: this.bidId,
      };
      this.$api
        .userBids(params)
        .then((res) => {
          if (res.code == 0) {
            that.bidDetail = res.data;
            that.firmName = res.data.company;
            that.firmAddress = res.data.address;
            that.firmReport = res.data.business;
            that.userName = res.data.name;
            that.userTel = res.data.mobile;
            that.duty = res.data.position;
            that.email = res.data.email;
            that.surrender = res.data.is_ensure;
            that.rebrink = res.data.remark;
            // let putfile={
            //   name:res.data.
            // }
          } else {
            that.$message({
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed() {
      this.$message({
        message: "只允许上传一个文件",
      });
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleChange(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList;
    },
    submit() {
      console.log(this.fileList);
      if (!this.$store.state.user) {
        this.$router.push({
          name: "signin",
          query: {
            redirect: this.$router.currentRoute.fullPath,
          },
        });
        return false;
      }
      let that = this;
      if (!this.firmName) {
        that.$message({
          message: "请填写公司名称",
        });
        return false;
      }
      if (!this.firmAddress) {
        that.$message({
          message: "请填写公司地址",
        });
        return false;
      }
      if (!this.firmReport) {
        that.$message({
          message: "请填写主营业务",
        });
        return false;
      }

      if (!this.userName) {
        that.$message({
          message: "请填写姓名",
        });
        return false;
      }
      if (!this.userTel) {
        that.$message({
          message: "请填写联系电话",
        });
        return false;
      }
      if (!this.duty) {
        that.$message({
          message: "请填写职务",
        });
        return false;
      }
      if (!this.email) {
        that.$message({
          message: "请填写邮箱",
        });
        return false;
      }
      var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!reg.test(this.email)) {
        that.$message({
          message: "请输入有效的邮箱",
        });
        return false;
      }
      if (!this.surrender) {
        that.$message({
          message: "请选择是否缴纳保证金",
        });
        return false;
      }
      if(!this.fileList&&!this.fileList.length){
        that.$message({
          message: "请上传附件",
        });
        return false;
      }
      this.upFile();
    },
    upFile() {
      let that = this;
      const formData = new FormData();
      formData.append("file", this.fileList[0].raw);
      let config = {
        headers: {
          "Content-Type": "mutipart/form-data",
        },
      };
      // http://yyg_admin.oeob.net/upload/upload-zip
      axios
        .post("http://yyg_admin.oeob.net/upload/upload-zip", formData, config)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            that.putfile =res.data.data.url;
            that.present();
          } else {
            that.$message({
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          that.common.message(that, err);
        });
    },
    present() {
      let that = this;
      let params = {
        company: this.firmName,
        address: this.firmAddress,
        business: this.firmReport,
        name: this.userName,
        mobile: this.userTel,
        position: this.duty,
        email: this.email,
        is_ensure: this.surrender,
        remark: this.rebrink,
        tender_id: this.bidId,
        file: this.putfile,
        file_name: this.fileList[0].name,
      };
      this.$api
        .refersubmit(params)
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.$message.success({
              message: "投标成功,静候佳音",
            });
            setTimeout(function () {
              that.$router.go(-1);
            }, 2000);
          } else {
            that.$message({
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          that.common.message(that, err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  box-sizing: border-box;
  background: #f2f2f2;
  padding-top: 10px;
  padding-bottom: 37px;
  .container {
    width: 1190px;
    margin: 0 auto;
    .left {
      width: 75%;
      float: left;
      background: #fff;
      padding-bottom: 41px;
      .left_wrap {
        margin: 0 22px;
        .basic {
          padding-top: 43px;
          .nav_title {
            display: flex;
            align-items: center;
            span {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #333333;
              line-height: 22px;
              margin-left: 3px;
            }
            &::before {
              content: "";
              width: 4px;
              height: 16px;
              background: #dd2727;
              display: block;
            }
          }
          .message {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .form-item {
              margin-top: 20px;
              .label {
                text-align: right;
                vertical-align: middle;
                float: left;
                font-size: 14px;
                color: #606266;
                line-height: 40px;
                padding: 0 12px 0 0;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 120px;
                &::before {
                  content: "*";
                  color: #f56c6c;
                  margin-right: 4px;
                }
              }
              .form-input {
                line-height: 40px;
                position: relative;
                font-size: 14px;
                margin-left: 120px;
                width: 300px;
              }
            }
          }
        }
        .relation {
          padding-top: 40px;
          .nav_title {
            display: flex;
            align-items: center;
            span {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #333333;
              line-height: 22px;
              margin-left: 3px;
            }
            &::before {
              content: "";
              width: 4px;
              height: 16px;
              background: #dd2727;
              display: block;
            }
          }
          .message {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .form-item {
              margin-top: 20px;
              .label {
                text-align: right;
                vertical-align: middle;
                float: left;
                font-size: 14px;
                color: #606266;
                line-height: 40px;
                padding: 0 12px 0 0;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 120px;
                &::before {
                  content: "*";
                  color: #f56c6c;
                  margin-right: 4px;
                }
              }
              .form-input {
                line-height: 40px;
                position: relative;
                font-size: 14px;
                margin-left: 120px;
                width: 300px;
              }
            }
          }
        }
        .other {
          padding-top: 40px;
          .nav_title {
            display: flex;
            align-items: center;
            span {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #333333;
              line-height: 22px;
              margin-left: 3px;
            }
            &::before {
              content: "";
              width: 4px;
              height: 16px;
              background: #dd2727;
              display: block;
            }
          }
          .message {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .form-item {
              margin-top: 20px;
              .label {
                text-align: right;
                vertical-align: middle;
                float: left;
                font-size: 14px;
                color: #606266;
                line-height: 40px;
                padding: 0 12px 0 0;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 160px;
                &::before {
                  content: "*";
                  color: #f56c6c;
                  margin-right: 4px;
                }
              }
              .label_ra {
                &::before {
                  content: "";
                }
              }
              .form-input {
                line-height: 40px;
                position: relative;
                font-size: 14px;
                margin-left: 160px;
                width: 300px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                min-height: 40px;
                .toast {
                  margin-top: 12px;
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;
                  line-height: 17px;
                }
              }
              .form-upload {
                line-height: 40px;
                position: relative;
                font-size: 14px;
                margin-left: 160px;
                min-width: 400px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                min-height: 40px;
                .upload_btn {
                  width: 124px;
                  height: 38px;
                  background: #f5f5f5;
                  border-radius: 2px;
                  border: 1px solid #e0e0e0;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                  line-height: 20px;
                }
                .toast {
                  margin-top: 12px;
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;
                  line-height: 17px;
                }
              }
            }
          }
        }
        .reload {
          margin-top: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          .reload_btn {
            width: 136px;
            height: 36px;
            background: #dd2727;
            border-radius: 3px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
            cursor: pointer;
          }
        }
      }
    }
    .right {
      width: calc(25% - 12px);
      margin-left: 12px;
      float: left;
      background: #fff;
      .content {
        padding-top: 20px;
        padding-bottom: 31px;
        .nav_title {
          display: flex;
          align-items: center;
          span {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 22px;
            margin-left: 16px;
          }
          &::before {
            content: "";
            width: 4px;
            height: 16px;
            background: #dd2727;
            display: block;
          }
        }
        .main {
          padding: 0 16px;
          .bidTitle {
            width: 100%;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
            margin-top: 20px;
          }
          .bidTime {
            padding-top: 12px;
            padding-bottom: 16px;
            border-bottom: dashed 1px #e6e6e6;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
            span {
              color: #dd2727;
            }
          }
          .fordetail {
            margin-top: 16px;
            .item {
              margin-top: 12px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 20px;
              display: flex;
              align-items: center;
              .label {
                flex-shrink: 0;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 20px;
                margin-right: 8px;
                width: 70px;
                text-align-last: justify;
              }
            }
            .item:first-child {
              margin-top: 0;
            }
          }
        }
      }
    }
  }
}
</style>